import React from "react"
import { Motion, spring } from "react-motion"
import Container from "./Container"

const MotionContainer = ({ children, inIframe = false }) => (
  <Motion
    defaultStyle={{ opacity: 0 }}
    style={{ opacity: spring(1, { stiffness: 20, damping: 10 }) }}
  >
    {(interpolatingStyle) => (
      <div style={interpolatingStyle}>
        <Container inIframe={inIframe}>{children}</Container>
      </div>
    )}
  </Motion>
)

export default MotionContainer
